import { Box } from "@mui/material";

export const ConditionMarker = () => (
  <Box
    className="condition-marker"
    sx={{
      left: 0,
      position: "absolute",
      width: "2px",
      height: "100%",
      bgcolor: "primary.main",
      borderRadius: "2px",
    }}
  />
);

export default ConditionMarker;
